module.exports = __webpack_public_path__ + "1de158f0dedcade59362a896605af682.pdf";